import type { HelpFile } from '../../types/help'
import { OwnersPickerTestIds } from '../../../testids/OwnersPickerTestIds'

export const ownersPickerHelp: HelpFile = {
  docPage: '/docs/governance/auto-assign-rule-requests',
  texts: {
    [OwnersPickerTestIds.ownersEditor]:
      'Pick one or more parties accountable for this entity. Each owner row carries a responsibility code (Business, Technical, …).',
    [OwnersPickerTestIds.btnAddOwner]:
      'Add another owner row.',
    [OwnersPickerTestIds.btnRemoveOwnerPrefix()]: null,
    [OwnersPickerTestIds.comboboxOwnerPartyPrefix()]: null,
    [OwnersPickerTestIds.ownerRowPrefix()]: null,
    [OwnersPickerTestIds.selectOwnerResponsibilityPrefix()]: null,
  },
}
